import { createLogger } from 'vuex';

const logger = process.env.NODE_ENV === 'production' ? () => {} : createLogger();
export default [logger];
